import { Component, Input, input, OnInit } from '@angular/core';
import { MenuItem } from 'primeng/api';
import { AuthenticationService } from 'src/app/core/service/authentication.service';
import { MenuService } from 'src/app/core/service/menu.service';
import { ActivatedRoute, Event, NavigationEnd, Router } from '@angular/router';
import { Location } from '@angular/common';
import { filter } from 'rxjs';

@Component({
  selector: 'app-nav-header',
  templateUrl: './nav-header.component.html',
  styleUrls: ['./nav-header.component.css']
})
export class NavHeaderComponent implements OnInit {
  @Input() CompanyID: string;
  @Input() UserID: string;
  @Input() Liff_ID: string;
  @Input() title: string;
  loginMember: any = {};
  isLoading: boolean = false;
  items: MenuItem[] | undefined;
  sidebarVisible: boolean = false;
  sidebarOpen = false;
  showBackButton = false;
  constructor(
    private authenticationService: AuthenticationService,
    private router: Router,
    private MenuService: MenuService, 
    private location: Location, 
    private activatedRoute: ActivatedRoute
  ) { 
    this.authenticationService.currentMember
            .subscribe(member => {
              console.log("取得登入者:"+member);
              this.loginMember = member;
            });
  }

  ngOnInit(): void { 
     // 订阅 Router 事件，判断是否显示返回按钮
    this.router.events
      .pipe(
        filter((e: Event): e is NavigationEnd => e instanceof NavigationEnd)
      )
      .subscribe((e: NavigationEnd) => {
        const currentRoute = this.getCurrentRoute(this.activatedRoute);
        const path = currentRoute.routeConfig?.path || '';
        this.showBackButton = path !== ''; // 首页隐藏返回按钮
        console.log('Current URL:', e.urlAfterRedirects, ' ShowBackBtn:', this.showBackButton);
      });

    // 手动触发一次逻辑，确保第一次加载也能判断
    const initialEvent = new NavigationEnd(0, this.router.url, this.router.url);
    const currentRoute = this.getCurrentRoute(this.activatedRoute);
    const path = currentRoute.routeConfig?.path || '';
    this.showBackButton = path !== '';
    console.log('Initial URL:', this.router.url, ' ShowBackBtn:', this.showBackButton);

    this.MenuService.GetMenu(this.CompanyID).subscribe(res =>{
        //由於Menuservice中的設定，只有首頁會去api取值，其他都直接有資料
        this.items = !!res.LineInfo?this.buildMenu(res.LineInfo):this.buildMenu(res);
    });
  }
  buildMenu(res: string) {
    const baseParams = {
      CompanyID: this.CompanyID,
      UserID: this.UserID,
      Liff_ID: this.Liff_ID
    };
    const menuMapping: Record<string, any> = {
      '0': { label: '首頁', svg: 'assets/images/family_home.svg', route: '/' },
      '1': { label: '美容預約', svg: 'assets/images/content_cut.svg', route: '/reservation' },
      '2': { label: '住宿預約', svg: 'assets/images/bed.svg', route: '/book' }, 
      '3': { label: '個人資料', svg: 'assets/images/person.svg', route: '/member' },
      '4': { label: '交易資訊', svg: 'assets/images/point_of_sale.svg', route: '/tranhistory' },
      '5': { label: '剩餘點數', svg: 'assets/images/attach_money.svg', route: '/balance' },
      '6': { label: '包月資訊', svg: 'assets/images/health_and_beauty.svg', route: '/memberSub' },
      '7': { label: '同意書', svg: 'assets/images/contract_edit.svg', route: '/consentForm' } ,
      '8': { label: '預約資訊', svg: 'assets/images/calendar_month.svg', route: '/searchRes' } 
    };
    //設定順序
    const menuOrder = ['1','2','3','4','5','6','7'];
    const addMenu = (key: string) => ({
      ...menuMapping[key],
      command: () => this.router.navigate([menuMapping[key].route], { queryParams: baseParams })
    });

    const items: any[]=[];
    const special = new Set<string>(); 
    special.add('0');
    if (["1", "3"].includes(res)) special.add('1'); // 美容
    if (["2", "3"].includes(res)) special.add('2'); // 住宿
    // 特殊項目依 menuMapping 順序插入
    [...special].forEach(key => items.push(addMenu(key)));

    menuOrder.forEach(e=>{
        if (!items.find(x => x.label === menuMapping[e].label)) { // 避免重複
          items.push(addMenu(e));
        }
    });
    if (res !== '0') items.push(addMenu('8'));
    
    return items;
  }
  goBack() {
      this.location.back();
  }

  getCurrentRoute(route: ActivatedRoute): ActivatedRoute {
    return route.firstChild ? this.getCurrentRoute(route.firstChild) : route;
  }
}
